module.exports = __webpack_public_path__ + "static/img/manual_ja_8.2cae0fd.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/ja/manual_ja_8.png
// module id = t3Rv
// module chunks = 4